import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article17() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });
  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });


  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img1 = document.getElementById("img2");
      img1.className = '';
      return "";
    }
    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';

      return "";
    }

  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article18');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article16');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article17-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article17-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">

          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article17-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
          <div className="" ref={firstContainer}>
            <h1 className="fs-xxl f-lora mb-4">Living in <br/><span className="f-lora-i">the past</span></h1>
            <h4 className="f-lora-i mb-4 mb-sm-5 fs-md">The ceiling is low and the walls are bare, the air is thick with peat smoke while the sound of cattle comes from the next room. This was life in a traditional Scottish blackhouse. </h4>
            
            <img className="img-fluid mb-4"
              src={require("../../Images/article17-right-img1.jpg")}
            />
            <img className="img-fluid mb-4"
              src={require("../../Images/article17-right-img2.jpg")}
            />
            <p className="f-lora-i mb-4 mb-sm-5">In the 1800s, blackhouses would have been a familiar sight to many across the Highlands and Islands. Today, they’re almost entirely consigned to history apart from a few important locations that are keeping this chapter of Scottish history alive. Stepping inside these evocative buildings is like travelling into the past, to a simpler albeit less comfortable time. </p>

            <div className="row mb-4">
              <div className="col-sm-6">
                <p className="">A popular theory explains that the name blackhouse came from the home’s lack of a chimney. As smoke from the peat fire escaped through the thatched roof it left blackened walls behind. Fortunately, that killed off any bugs that might be making their home up there as well as having another surprising benefit. When the time came to re-thatch the roof, the old smoked material made perfect fertiliser for the fields. </p>
                <p className="">In reality, these buildings had no special name until a newer style known as white houses were introduced. Improved sanitation regulations encouraged people to move into sturdier buildings, with solid roofs and whitewashed walls. That was when the older and much darker homes became known as blackhouses to differentiate. </p>
                <p className="">One story tells of an old man who had lived his entire life in blackhouses, finally moving into a nursing home in his twilight years. When the staff commented on how soft and unblemished his skin was, he credited it to spending every day surrounded by peat smoke! </p>
              </div>
              <div className="col-sm-6">
                <p className="">In 1860, the Laird of Raasay’s tutor noticed that very few islanders were succumbing to tuberculosis at a time when it was a major killer elsewhere. After confirming with local doctors that the situation was similar across the Hebrides, he theorised that the disease was kept at bay by the regular inhalation of peat smoke! </p>
                <p className="">The design was perfect for Scotland’s climate, especially on the islands, with low-rising, double-layered drystone walls and rounded roofs perfect for dealing with strong winds. Lengths of grass or heather kept out the rain, secured by ropes weighted with heavy stones. Usually, there was only one door, sometimes a window or two, but extra openings were just escape routes for heat. </p>
                <p className="">Inside, the space was divided into two or three long rooms. One was for the family to live and eat, sometimes another to sleep, while the last was a space for farm animals. It </p>
              </div>
            </div>

            <img className="img-fluid mb-4 mb-sm-5"
              src={require("../../Images/article17-right-img3.jpg")}
            />

            <div className="row mb-4">
              <div className="col-sm-6">
                <p className="">might have smelled a little, but the warmth from those beasts would be more than welcome in the winter. </p>
                <p className="">The most famous blackhouses in Scotland can be found at the township of Gearrannan on the Isle of Lewis, built in the late 1800s beside a small bay looking out to the Atlantic Ocean. Where many blackhouses were abandoned, the village at Gearrannan tried to adapt to changing times, lived in as recently as the 1970s. </p>
                <p className="">Rather than move into newer buildings, residents of Gearrannan upgraded to electricity in the 1950s and then piped water shortly afterwards. However, modern improvements marked the beginning of the end of this way of life. </p>
                <p className="">With fresh water on tap, laundry was no longer washed together down in the loch and regular milk deliveries meant no more need for keeping cows. The updates weren’t enough to convince the children of blackhouses to continue this traditional way of life. Without younger generations living there to help maintain the thatched stone buildings, the last elderly residents moved out in 1974. </p>
              </div>
              <div className="col-sm-6">
                <p className="">All hasn’t been lost, however. Thanks to The Gearrannan Trust, visitors can now learn what life was like in a community of blackhouses. Wander the village down to the beach, learn how the buildings were constructed and for those who truly want to immerse themselves, some can be rented as self-catered accommodation! </p>
                <p className="">For an earlier example, Arnol Blackhouse can be found just a short distance along the coast. Built without windows or a chimney, Arnol shows the traditional design that Scottish islanders would have recognised centuries earlier. The fire sits in the middle of the floor with a pot hanging above, around which neighbours would gather on dark nights to share stories and local gossip. </p>
                <p className="">You don’t have to head to the Outer Hebrides to experience the humble blackhouse, however. Reconstructions can be found at the Museum of Island Life in Skye as well as the Highland Folk Museum at Kingussie. In both locations, visitors learn about every aspect of traditional life during those times from the homes that were inhabited to the tools once worked with. </p>
              </div>
            </div>



          </div>
          <div className="" ref={secondContainer}>
            <img className="img-fluid mb-4 mb-sm-5"
              src={require("../../Images/article17-right-img4.jpg")}
            />

            <div className="row mb-4">
              <div className="col-sm-6">
                <p className="">These iconic blackhouses were only one stage in this style of dwelling in Scotland that stretches back centuries. Their drystone design replaced much earlier turf houses which have all but disappeared, crumbling back into the ground from where they came. </p>
                <p className="">A house made mostly from earth might not sound like a warm, secure place to live, but that can be disproved at the Glencoe Visitor Centre. The National Trust for Scotland has recently reconstructed a thatched turf house using only traditional methods. </p>
                <p className="">Built with earth walls, wattle and daub on the inside and thatch on the roof, the reconstruction is the same footprint as a building excavated at Achtriachtan. The inside is nearly identical to the blackhouses of the Outer Hebrides, showing that traditional homes have changed little. With so many people visiting Glencoe to hear how the MacDonalds died, this is a welcome addition to demonstrate how they lived as well. </p>
                <p className="">Traditional blackhouses may have become less common in the 1900s, but even when the buildings changed, some townships clung to their way of life. Nowhere is that more </p>
              </div>
              <div className="col-sm-6">
                <p className="">evident than at Auchindrain, just a short distance south of Inveraray. This township boasts slightly more modern buildings, some with tin roofs, but the parallels with the blackhouses of Gearrannan are unmistakable. </p>
                <p className="">Auchindrain was still lived in until the 1960s, with the land being worked as it had been for generations. Very little has changed since then, both with the buildings and the landscape. Visitors explore the open-air museum as if they’ve stepped right into another time, without any information boards to detract from that experience. </p>
                <p className="">These locations all share the story of people whose existence was intrinsically woven into the land and the passing of the seasons. It’s a traditional way of life that’s easily lost in the modern age, but there are plenty of places left in Scotland where it can be rediscovered. </p>
              </div>
            </div>
            
          </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article17;
